/* https://weblog.west-wind.com/posts/2023/Jan/26/HTML-Table-Cell-Overflow-Handling */
.ellipsis {
  max-width: 14rem;

  > div {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.activityCell {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.onlineDot {
  flex: none;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background-color: var(--interactive-default);
}
